import TextField from '@mui/material/TextField';

import { styled } from "@mui/material";

const MultiLineTextStyled = styled(TextField)(({theme}) => ({
    '& .MuiInputBase-root': {
        padding: '16px'
    },
    '& .MuiFormHelperText-root': {
        marginLeft: 0,
        marginBottom: theme.spacing(1.5)
    },
    textarea: {
        resize: 'vertical',
        overflow: 'hidden',
        width: '100%',
        marginTop: '-4px',
        minHeight: '20px',
        lineHeight: 'normal',
        color: 'var(--mui-palette-primary-textColor)'

    }
  }));

const MultiLineText = (props) => {
    return (
        <MultiLineTextStyled
            {...props}
            fullWidth
            id="outlined-multiline-static"
            multiline
            // defaultValue="Default Value"
        />
    )
}


export default MultiLineText;